(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('wizardItemV2', ["path", "wizardHelper", "appConfigurator", "licenseOptions", "dualAppHelper", "termsModal", "modulesDao", "appStoreHelper", "$rootScope", function (path, wizardHelper, appConfigurator, licenseOptions, dualAppHelper, termsModal, modulesDao, appStoreHelper, $rootScope) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('wizard-item-v2').template(),
            scope: { model: '=wizardItemV2' },
            link: function ($scope, element, attrs) {
                $scope.itemImage = $scope.model.options.img.path2 ? path('gui-v2').imgRel($scope.model.options.img.path2) : path('app-store').imgRel($scope.model.options.img.path);
                $scope.operationInProgress = function () {
                    return wizardHelper.operationInProgress($scope.model.options.moduleName);
                };
                if (appStoreHelper.isO365($scope.model.options.moduleName)) {
                    appStoreHelper.checkO365AuthorizedStatus($scope.model.options.moduleName);
                }
                $scope.startButton = {
                    enabled: $scope.model.options.lockActions ? false : wizardHelper.showActivateButton($scope.model.options.moduleName),
                    label: $scope.model.options.lockActions ? 'Deactivating...' : 'Started',
                    execute: function (isStarted) {
                        var checkModules = dualAppHelper.checkDualApp($scope.model.options.moduleName);
                        if (checkModules.isDualApp) {
                            return dualAppHelper.authenticationStatus(checkModules.authName, $scope.model.options.moduleName).then(function (response) {
                                if (response.data.hasOwnProperty('step')) {
                                    $scope.model.options.currentStep = response.data.step;
                                    if (wizardHelper.scope().stepInfo.terms && !wizardHelper.scope().terms.accepted) {
                                        return termsModal.show({ termsUrl: wizardHelper.scope().stepInfo.termsUrl }).then(function () {
                                            wizardHelper.scope().acceptTerms();
                                            dualAppHelper.dualAppWizard($scope.model.options);
                                        });
                                    }
                                    dualAppHelper.dualAppWizard($scope.model.options);
                                } else if (response.data.hasOwnProperty('done')) {
                                    wizardHelper.activateDualApp($scope.model.options.moduleName);
                                }
                            });
                        } else {
                            if (isStarted) {
                                wizardHelper.activateApp($scope.model.options.moduleName, false, $scope.model.options);
                            } else {
                                if (appStoreHelper.isO365($scope.model.options.moduleName) && !appStoreHelper.checkO365AuthorizedStatus($scope.model.options.moduleName)) {
                                    appStoreHelper.o365AppInstallationModal($scope.model.options);
                                } else if ($scope.model.options.moduleName === 'sharefile') {
                                    appStoreHelper.shareFileAlert().then(function () {
                                        wizardHelper.activateApp($scope.model.options.moduleName);
                                    });
                                } else {
                                    wizardHelper.activateApp($scope.model.options.moduleName);
                                }
                            }
                        }
                    }
                };
                $scope.contactSupport = {
                    enabled: $scope.model.options.options && $scope.model.options.options.license === 'contact_support' && $scope.model.options.moduleStatus !== 'display_only' && $scope.model.options.moduleStatus !== 'require_license',
                    execute: function () {
                        licenseOptions.contactSupportDialog($scope.model.options);
                    }
                };
                $scope.configure = function () {
                    if (appConfigurator.configAvailable($scope.model.options, true)) {
                        return appConfigurator.configure($scope.model.options, true, undefined, undefined, true);
                    }
                };
                $scope.$on('configure-app', function (event, args) {
                    if (args.app === $scope.model.options.moduleName) {
                        $scope.configure();
                    }
                });
                if ($rootScope.saasAuthStarted && $scope.startButton.enabled && $rootScope.saasAuthStarted === $scope.model.options.moduleName && $scope.model.options.saasAuthorized && $scope.model.options.options && $scope.model.options.options.operation === 'start') {
                    $scope.startButton.execute(true);
                }
            }
        };
    }]);
}());